import { http } from '../common/http-client';
import { getAuthUrl } from './utils';

export const refreshToken = async () => {
  const data = await http
    .get('oauth2/refresh', {
      prefix: '/',
    })
    .json<{ access_token: string }>();

  return data.access_token;
};

export const logout = async () => {
  await http.get('oauth2/logout', {
    prefix: '/',
  });
};

export const redirectToLoginPage = (
  redirect_to: string = window.location.href,
) => {
  window.location.href = getAuthUrl(redirect_to);
};
